import React from 'react';
import { useTranslation } from 'react-i18next';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLang);
  };

  return (
    <div className="privacy-policy">
      <div className="privacy-header">
        <button onClick={() => window.history.back()} className="back-button">
          ← {t('backToHome')}
        </button>
        <button onClick={toggleLanguage} className="language-toggle">
          {i18n.language === 'fr' ? 'EN' : 'FR'}
        </button>
      </div>

      <div className="privacy-content">
        <h1>{t('privacyTitle')}</h1>
        <p className="last-updated">
          <strong>{t('lastUpdated')}</strong> {t('lastUpdatedDate')}
        </p>

        <p className="welcome-text">{t('privacyWelcome')}</p>

        <section>
          <h2>1. {t('dataCollected')}</h2>
          <ul>
            <li>{t('userAccount')}</li>
            <li>{t('savedContent')}</li>
            <li>{t('technicalData')}</li>
            <li>{t('subscriptionData')}</li>
          </ul>
          <p><strong>{t('noSensitiveData')}</strong></p>
        </section>

        <section>
          <h2>2. {t('dataUsage')}</h2>
          <p>{t('dataUsedFor')}</p>
          <ul>
            <li>{t('createAccount')}</li>
            <li>{t('saveLinks')}</li>
            <li>{t('improvePerformance')}</li>
            <li>{t('manageSubscriptions')}</li>
          </ul>
        </section>

        <section>
          <h2>3. {t('dataSharing')}</h2>
          <p>{t('noDataSale')}</p>
          <p>{t('dataSharedWith')}</p>
          <ul>
            <li>{t('technicalProviders')}</li>
            <li>{t('legalAuthorities')}</li>
          </ul>
        </section>

        <section>
          <h2>4. {t('security')}</h2>
          <p>{t('securityMeasures')}</p>
        </section>

        <section>
          <h2>5. {t('yourRights')}</h2>
          <p>{t('gdprCompliant')}</p>
          <ul>
            <li>{t('accessData')}</li>
            <li>{t('requestCorrection')}</li>
            <li>{t('objectProcessing')}</li>
            <li>{t('requestPortability')}</li>
          </ul>
          <p>{t('exerciseRights')} <a href="mailto:support@klipiz.com">support@klipiz.com</a></p>
        </section>

        <section>
          <h2>6. {t('retentionPeriod')}</h2>
          <p>{t('dataRetention')}</p>
        </section>

        <section>
          <h2>7. {t('modifications')}</h2>
          <p>{t('policyUpdates')}</p>
        </section>

        <section>
          <h2>8. {t('contact')}</h2>
          <p>{t('privacyQuestions')} <a href="mailto:support@klipiz.com">support@klipiz.com</a></p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 